// Mantis theme configuration
import { createTheme, ThemeOptions } from '@mui/material/styles';
import Palette from './palette';
import Typography from './typography';
import Shadows from './shadows';
import ComponentsOverrides from './overrides';

export default function createMantisTheme(mode: 'light' | 'dark' = 'light') {
  const palette = Palette(mode);

  // Create base theme with palette and typography
  const baseTheme = createTheme({
    palette,
    typography: Typography(),
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 900,
        lg: 1200,
        xl: 1536
      }
    }
  });

  // Create final theme with shadows and component overrides
  const themeOptions: ThemeOptions = {
    ...baseTheme,
    shadows: Shadows(baseTheme) as any,
    components: ComponentsOverrides(baseTheme)
  };

  return createTheme(themeOptions);
}
